import { useEffect, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout"
import { Card, CardContent, Grid2, IconButton, Stack } from "@mui/material";
import MaterialSelect from "../../components/MasterSelect";
import MaterialBox from "../../components/MaterialBox";
import MaterialTypography from "../../components/MaterialTypography";
import AddBoxIcon from '@mui/icons-material/AddBox';
import MaterialInput from "../../components/MaterialInput";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { useLoading } from "../../context/loading";
import { creatept, deletept, getallpt, updatept } from "./mutation";
import Swal from "sweetalert2";
import axios from "axios";
import BASEURL from "../Utils/Baseurl";
import MaterialButton from "../../components/MaterialButton";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import ConfirmationDialog from "../../components/Dialog/ConfirmationDialog";

const ProfesionalTax =()=>{
     const { setCirleLoading } = useLoading();
   
   
const monthoption = [

  { value: 1, label: "January" },
  { value: 2, label: "February" },
  { value: 3, label: "March" },
  { value: 4, label: "April" },
  { value: 5, label: "May" },
  { value: 6, label: "June" },
  { value: 7, label: "July" },
  { value: 8, label: "August" },
  { value: 9, label: "September" },
  { value: 10, label: "October" },
  { value: 11, label: "November" },
  { value: 12, label: "December" }

];
const[update,setupdate] = useState(false)
const[months,setmonths] = useState([  { startMonth: {value:0,label:""}, endMonth: {value:0,label:""} },])
const[slabs,setslabs] = useState([    { salaryFrom: 0, salaryTo: 0, ptAmount: 0 },{ salaryFrom: 0, salaryTo: null, ptAmount: 0 },])
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

const[error,seterror] = useState(["success"])

const[Allmonthschoosen,setallmonthschoosen] = useState(false)
 

console.log(slabs,months,"sml");


useEffect(()=>{

   setallmonthschoosen(istotal_month_exceeds_12 ())

},[months])

useEffect(()=>{

fetchallPT()

},[])



const handlemonthchange = (value,ind,month)=>{
    setmonths((prev)=>{
        const updatedmonth = [...prev]
      updatedmonth[ind][month] = value;
      return updatedmonth;
    })
  }

  const handleslabchange =(value,ind,type)=>{
   setslabs((prev)=>{
    const prevslab = [...prev]

    prevslab[ind][type] = value

    return prevslab;
   })

   if(type=="salaryTo"){
      setslabs((prev)=>{
    const prevslab = [...prev]
    
    seterror((prev)=>{
      const updatederror = [...prev]
      updatederror[ind] = prevslab[ind]["salaryFrom"]>Number(value)?"error":"success"
      return updatederror;
    })
    


    prevslab[ind+1]["salaryFrom"] = Number(value)+1
     
    return prevslab;
   })
   }

  }

  const handledelete=(type,index)=>{
   
    if(type=="slab"){
   setslabs((prev) => {
      let updated = [...prev];

      // remove one slab
      updated = updated.filter((_, ind) => ind !== index);

    
      if (updated.length > 0) {
        updated[updated.length - 1].salaryTo = 0;
      }

      return updated;
    });
    }
    else{
        setmonths((prev)=>{
        const updated = [...prev]
       return updated.filter((_,ind)=>ind!=index)
    })
    }
  }

  const handletaxdelete =async()=>{
   
     setCirleLoading(true);
      
    
      try {
        const response = await axios.post(
          BASEURL,
          {
            query:deletept,
          
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
         
          let success =null;
          let message =null; 
         
          success = response?.data?.data?.deletePtConfig?.success
          message = response?.data?.data?.deletePtConfig?.message
         

        if (success) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: message,
            showConfirmButton: false,
            timer: 2500,
          });
        //   setnewlycreatedlevel(response?.data?.data?.createLevel?.level)
        //   fetchalllevel()
        //   setallupdatedlevels(alllevels)
        } else {
          Swal.fire({
            position: "center",
            icon: "error",
            title: message,
            showConfirmButton: false,
            timer: 2500,
          });
        }
       
      } catch (err) {
        
      } finally {
        setCirleLoading(false);
        fetchallPT()
      }


  }




  const addslabormonth =(type)=>{
    if(type=="slab"){

        seterror((prev)=>([
            ...prev,
            "success"
        ]))
      setslabs((prev)=>([
        ...prev,
         { salaryFrom: 0, salaryTo: 0, ptAmount: 0 }
      ]))
    }
    else{
        setmonths((prev)=>([
            ...prev,
            { startMonth: {value:0,label:""}, endMonth: {value:0,label:""} }

        ]))
    }
  }
  
  const filteroption =(ind,month)=>{
       
    if(ind==0 &&month=="start"){
        return monthoption;
    }

    let last_selectedmonth =null

     if(month=="start"){
         last_selectedmonth =  months[ind-1]["endMonth"]["value"]
    
    }
    else{
           last_selectedmonth =  months[ind]["startMonth"]["value"]
         
    }
    return [
  ...monthoption.filter(m => m.value > last_selectedmonth),
  ...monthoption.filter(m => m.value < last_selectedmonth)
];
  }

  const disabledropdown =(ind,month)=>{
    let disable=null;
      
     if(month=="end"){
       disable = months[ind]?.startMonth?.value!=-1?false:true
     }  
     else{
        if(ind==0){
            return false;
        }
         disable = months[ind-1]?.endMonth?.value!=-1?false:true
     }

     return disable;


  }



const istotal_month_exceeds_12 = () => {
  let sum = 0;

  for (let i = 0; i < months.length; i++) {

    console.log(months,"in for");
    
    const start = months[i]?.startMonth?.value || 0;
    const end = months[i]?.endMonth?.value || 0;

    if (start === 0 || end === 0) continue; // skip incomplete rows

    sum += Math.abs(end - start )+ 1;
  }

  console.log(sum, "sum434");

  return sum >= 12;
};


  const getmonthobject_usingvalue =(value)=>{
   return monthoption.filter((month)=>month?.value==Number(value))?.[0]
  }


      const CreateorUpdatePT = async () => {
      setCirleLoading(true);
      const monthpayload =months?.map((month)=>({
        startMonth:month?.startMonth?.value,
        endMonth:month?.endMonth?.value
      }))

      const slabpayload =slabs?.map((slab)=>({
        salaryFrom: slab?.salaryFrom, salaryTo: slab?.salaryTo, ptAmount: slab?.ptAmount
      }))
      let input = {
       months:monthpayload,
       slabs:slabpayload
      };
    
      try {
        const response = await axios.post(
          BASEURL,
          {
            query:update?updatept: creatept,
            variables: input
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
         
          let success =null;
          let message =null; 
           if(update){
          success = response?.data?.data?.updatePtConfig?.success
          message = response?.data?.data?.updatePtConfig?.message
           }
           else{
          success = response?.data?.data?.createPtConfig?.success
          message = response?.data?.data?.createPtConfig?.message
           }


        if (success) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: message,
            showConfirmButton: false,
            timer: 2500,
          });
        //   setnewlycreatedlevel(response?.data?.data?.createLevel?.level)
        //   fetchalllevel()
        //   setallupdatedlevels(alllevels)
        } else {
          Swal.fire({
            position: "center",
            icon: "error",
            title: message,
            showConfirmButton: false,
            timer: 2500,
          });
        }
       
      } catch (err) {
        
      } finally {
        setCirleLoading(false);
        fetchallPT()
      }
    };


          const fetchallPT = async () => {
    setCirleLoading(true);

    try {
      let response = await axios.post(
        BASEURL,
        {
          query: getallpt,
          
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response?.data?.data?.getAllPtConfig,"allle");
      
        response = response?.data?.data?.getAllPtConfig

        let updatedmonths  = null;
        updatedmonths = response?.months
        console.log(updatedmonths,"424");
        
        if(updatedmonths?.length==0){
            setmonths( [{ startMonth: {value:0,label:""}, endMonth: {value:0,label:""} }])
            setupdate(false)
        }

        else{

     
            setupdate(true)
           updatedmonths = response?.months?.map((month)=>({

            startMonth:month?.startMonth?getmonthobject_usingvalue(month?.startMonth):[],
            endMonth:month?.endMonth?getmonthobject_usingvalue(month?.endMonth):[]
        }))

        console.log(updatedmonths,"57dd");
        
     setmonths(updatedmonths.length==0? [{ startMonth: {value:0,label:""}, endMonth: {value:0,label:""} }] : updatedmonths)

     console.log(response.slabs,"sl332");
        }

    
     
     setslabs(response?.slabs.length==0?[    { salaryFrom: 0, salaryTo: 0, ptAmount: 0 },{ salaryFrom: 0, salaryTo: null, ptAmount: 0 }]  :response?.slabs)
       
    } catch (error) {
      console.log("ResponseError:", error);
    } finally {
      setCirleLoading(false);
    }
  };

   

  const isallmonthpresent = ()=>{
   for(let i=0;i<months.length;i++){
      if(months[i]?.startMonth?.value<1 || months[i]?.endMonth.value<1){
        return false;
      }
   }

   return true;
  }

  const isallslabpresent =()=>{
     for(let i=0;i<slabs.length;i++){
      if(slabs[i]?.ptAmount<0 || slabs[i]?.salaryTo<1){
          if(i==slabs.length-1){
          return  slabs[i]?.ptAmount>1?true:false
          }
        return false;
      }
   }
    return true;
  }

  

    const Deletetax = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete Tax.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        handletaxdelete();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
    

  

    return(
    <DashboardLayout>
              {confirmationDialog.open && (
                <ConfirmationDialog
                  open={confirmationDialog.open}
                  title={confirmationDialog.title}
                  message={confirmationDialog.message}
                  showCancel={confirmationDialog.showCancel}
                  showConfirm={confirmationDialog.showConfirm}
                  customSection={confirmationDialog.customSection}
                  onConfirm={confirmationDialog.onConfirm}
                  onCancel={confirmationDialog.onCancel}
                />
              )}
        <Card>
            <CardContent>
                   <Stack direction="row" spacing={100}>
                    <MaterialTypography variant="h5" fontWeight="medium" style={{width:"50%"}}>
                      Professional Tax 
                    </MaterialTypography>
                     

                     <IconButton  sx={{color:"red"}} onClick={Deletetax}>
                        <HighlightOffIcon />
                     </IconButton>

                  </Stack>
                         <Grid2 size={{xs:12,md:12,lg:2}} container spacing={1}>
          {
            months?.map((month,ind)=>(
                <Grid2 key={ind} container spacing={1}  size={{xs:12,md:12,lg:12}}> 
                  <Grid2 size={{xs:12,md:6,lg:3}}>
                    
                                    <MaterialBox lineHeight={0} display="inline-block">
                                                   <MaterialTypography
                                                     component="label"
                                                     variant="caption"
                                                     fontWeight="bold"
                                                   >
                                                     Start Month
                                                   </MaterialTypography>
                                                 </MaterialBox>

                                                     <MaterialSelect
                                                                   name="stardate"
                                                                   value={month?.["startMonth"]}
                                                                         onChange={(e)=>handlemonthchange(e,ind,"startMonth")}
                                                                   menuPortalTarget={document.body}
                                                                   menuPosition={"fixed"}
                                                                   isDisabled={disabledropdown(ind,"start")}
                                                                   options={filteroption(ind,"start")}
                                                                   customStyles={{
                                                                     optionPadding: 2,
                                                                     optionMinWidth: 150,
                                                                   }}
                                                              
                                                                   // isLoading={isStateLoading}
                                                                 />
                    </Grid2>

                  <Grid2 size={{xs:12,md:6,lg:3}}>
                    
                                    <MaterialBox lineHeight={0} display="inline-block">
                                                   <MaterialTypography
                                                     component="label"
                                                     variant="caption"
                                                     fontWeight="bold"
                                                   >
                                                     End Month
                                                   </MaterialTypography>
                                                 </MaterialBox>

                                                     <MaterialSelect
                                                                   name="enddate"
                                                                   value={month?.["endMonth"]}
                                                                   onChange={(e)=>handlemonthchange(e,ind,"endMonth")}
                                                                   menuPortalTarget={document.body}
                                                                   menuPosition={"fixed"}
                                                                      isDisabled={disabledropdown(ind,"end")}
                                                                 options={filteroption(ind,"end")}
                                                                   customStyles={{
                                                                     optionPadding: 2,
                                                                     optionMinWidth: 150,
                                                                   }}
                                                              
                                                                   // isLoading={isStateLoading}
                                                                 />
                    </Grid2>
                  
               

                  <Grid2 size={{xs:12,md:6,lg:2}} sx={{display:"flex",alignItems:"flex-end"}}>
                     {months.length>1 &&  <IconButton sx={{color:"red"}}  onClick={()=>handledelete("month",ind)}>
                  <DeleteOutlineIcon />
                  </IconButton>}
                     {
                months.length-1==ind && !Allmonthschoosen&&
              <IconButton sx={{color:"green"}} onClick={()=>addslabormonth("month")}>
             <AddBoxIcon />
              </IconButton>}

              

                  </Grid2>


                </Grid2>

            ))
          }
      </Grid2>

           <Grid2 size={{xs:12,md:12,lg:12}} container spacing={1} mt={2}>
              <Stack direction="row" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                       Tax Slab
                    </MaterialTypography>

                  </Stack>
              <MaterialBox sx={{width:"100%"}}>
                  <Grid2 container spacing={2}  size={{xs:12,md:12,lg:12}}>
                        {/* <Grid2 size={{ xs: 12, md: 1,lg:2 }}>
                          <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                            <MaterialTypography
                              component="label"
                              variant="caption"
                              fontWeight="bold"
                              textTransform="capitalize"
                            >
                              S. No
                            </MaterialTypography>
                          </MaterialBox>
                        </Grid2> */}
                          <Grid2 size={{ xs: 12, md: 2,lg:1 }} >
                          <MaterialBox   lineHeight={0} display="inline-block">
                            <MaterialTypography
                              component="label"
                              variant="caption"
                              fontWeight="bold"
                              textTransform="capitalize"
                            >
                              S.NO
                            </MaterialTypography>
                          </MaterialBox>
                        </Grid2>
                        <Grid2 size={{ xs: 12, md: 2,lg:3 }} >
                          <MaterialBox   lineHeight={0} display="inline-block">
                            <MaterialTypography
                              component="label"
                              variant="caption"
                              fontWeight="bold"
                              textTransform="capitalize"
                            >
                              From Amount (Rs)
                            </MaterialTypography>
                          </MaterialBox>
                        </Grid2>
                        <Grid2 size={{ xs: 12, md: 2,lg:3 }}>
                          <MaterialBox  lineHeight={0} display="inline-block">
                            <MaterialTypography
                              component="label"
                              variant="caption"
                              fontWeight="bold"
                              textTransform="capitalize"
                            >
                              To Amount (Rs)
                            </MaterialTypography>
                          </MaterialBox>
                        </Grid2>
                
                    
                
                        <Grid2 size={{ xs: 12, md: 2,lg:3 }}>
                          <MaterialBox  lineHeight={0} display="inline-block">
                            <MaterialTypography
                              component="label"
                              variant="caption"
                              fontWeight="bold"
                              textTransform="capitalize"
                            >
                              Taxable Amount
                            </MaterialTypography>
                          </MaterialBox>
                        </Grid2>
                
                        <Grid2 size={{ xs: 12, md: 2,lg:2 }}>
                          <MaterialBox  lineHeight={0} display="inline-block">
                            <MaterialTypography
                              component="label"
                              variant="caption"
                              fontWeight="bold"
                              textTransform="capitalize"
                            >
                              Delete
                            </MaterialTypography>
                          </MaterialBox>
                        </Grid2>
                      </Grid2> 

                      {
                      slabs?.map((slab,ind)=>(
                      <MaterialBox key={ind} style={{padding:3}}>
                      <Grid2 container spacing={2}  size={{xs:12,md:12,lg:12}}>
                         <Grid2 size={{ xs: 12, md: 1,lg:1 }}>
                                     <MaterialInput disabled placeholder="S. No" value={ind + 1} />
                                   </Grid2>

                                  <Grid2 size={{ xs: 12, md: 2,lg:3 }}>
                   <MaterialInput
                name="fromAmount"
                placeholder="From Amount"
                value={slab.salaryFrom || 0}
             
                icon={{
                  direction: "right",
                  component: <CurrencyRupeeIcon size={18} color="black" />,
                }}
                disabled={true}
              />
            </Grid2>   

    <Grid2 size={{ xs: 12, md: 2,lg:3 }}>
                   <MaterialInput
                name="toAmount"
                placeholder="to Amount"
                value={ slabs.length-1 ==ind?"Above": slab.salaryTo || ""}
                onChange={(e)=>handleslabchange(e.target.value,ind,"salaryTo")}
                icon={{
                  direction: "right",
                  component: <CurrencyRupeeIcon size={18} color="black" />,
                }}
                disabled={slabs.length-1==ind}
                error={error[ind]=="error"?true:false}
              />
            </Grid2>     

                <Grid2 size={{ xs: 12, md: 2,lg:3 }}>
                   <MaterialInput
                name="taxable amount"
                placeholder="tax amount"
                value={slab.ptAmount || ""}
                onChange={(e)=>handleslabchange(e.target.value,ind,"ptAmount")}
                icon={{
                  direction: "right",
                  component: <CurrencyRupeeIcon size={18} color="black" />,
                }}
                // disabled={slabs.length-1==ind}
              />
            </Grid2>    


                     <Grid2 size={{ xs: 12, md: 2,lg:2 }} sx={{display:"flex"}}>
                        {slabs.length>1 &&
                             <IconButton sx={{color:"red"}} onClick={()=>handledelete("slab",ind)}>
                  <DeleteOutlineIcon />
                  </IconButton>
                        }
               

                   {
                slabs.length-1==ind&&
                   
                    <IconButton sx={{color:"green",display:"flex",alignItems:"flex-start"}} onClick={()=>addslabormonth("slab")}>
                        <AddBoxIcon/>
                    </IconButton>
}
            </Grid2>             

                      </Grid2>
                      </MaterialBox>
                      ))}
              </MaterialBox>

              <MaterialBox>
              
              
              </MaterialBox>
           </Grid2>
            </CardContent>
              <MaterialBox
                      display="flex"
                      justifyContent="flex-end"
                      alignItems="center"
                    >
                    
                        <>
                       
                          <MaterialButton
                            sx={{ m: 2, marginLeft: "4px" }}
                            variant="gradient"
                            color="dark"
                            disabled={!isallmonthpresent() || !isallslabpresent()}
                            onClick={CreateorUpdatePT}
                          >
                           { update ?"update":"submit"}
                          </MaterialButton>
                        </>
                      
          
                    </MaterialBox>
        </Card>
   
    </DashboardLayout>
    )
}

export default ProfesionalTax